export default __webpack_public_path__ + "static/media/logo scania_preguntas.4bc43c54.png";